import ShopIcon from '../../../assets/icons/ShopIcon';
import ActionButton from '../../../components/actionButton/ActionButton';
import { ProductService } from '../../../services/productService/ProductService';
import * as style from './style.css';
import NumberInput from '../../../components/numberInput/NumberInput';
import React = require('react');

interface IProps {
    productId: number;
    uriBuild: (path: string) => string;
    productService: ProductService;
    prodName: string;
}
interface IState {
    quantity: number;

}

export default class BuyAction extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            quantity: 1
        };
    }

    render() {
        return (
            <div className={style.buyAction}>
                <div className={style.quantity}>
                    <NumberInput
                        value={this.state.quantity}
                        onChange={v => this.updateQuantity(v)}
                    />

                </div>
                <div className={style.button}>

                    <ActionButton
                        label={'Dodaj do koszyka'}
                        onClick={() => this.addToBasket()}
                    >
                        <div style={{ margin: '0 10px' }}>
                            <ShopIcon />

                        </div>
                    </ActionButton>
                </div>
            </div>
        );
    }

    addToBasket(): void {
        this.props.productService.addToBasket(this.props.productId, this.props.prodName, this.state.quantity);
    }

    updateQuantity(value:number): void {
        this.setState({ quantity: value });
    }
}
